import { render } from "./AreaDetails.vue?vue&type=template&id=65c1c45b"
import script from "./AreaDetails.vue?vue&type=script&lang=js"
export * from "./AreaDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__